<template>
  <div v-if="isMounted" :key="settings.icon" class="loader vx-col w-1/2 md:w-1/3 xl:w-1/6 ">
    <statistics-card-line 
      hideChart
      class="mb-base"
      :icon="settings.icon" 
      :statistic="settings.value"
      :statisticTitle="settings.label"
    />
 
  </div>

  
</template>

<script>
import StatisticsCardLine from "./StatisticsCardLine.vue";
export default {
  data() {
    return {
      isMounted: false
    };
  },
  components: {
    StatisticsCardLine
  },
  props: {
    settings: Object,
    default: {}
  },
  created() {
    console.log("settings in stat:", this.settings);
    this.isMounted = true;
  }
};
</script>